// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"48134ace","239":"248e4e77","455":"d98362bb"}[chunkId] + ".chunk.js";
};